import API from '..';
const ENTITY = 'winds';

export const createItem = (data) => API.post(`/api/v1/${ENTITY}/`, data);

export const getItem = (id) => API.get(`/api/v1/${ENTITY}/${id}/`);

export const getItems = ({
    country,
    orderBy,
    page = 1,
    perPage = 25,
    search,
    sort,
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            page: page,
            per_page: perPage,
            country,
            ...(orderBy ? { order_by: orderBy } : {}),
            search,
            sort,
        },
    });

export const updateItem = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}/`, data);

export const deleteItem = (id) => API.delete(`/api/v1/${ENTITY}/${id}/`);

export const bulkItems = (data) =>
    API.put(
        `/api/v1/${ENTITY}/bulk-status/`,
        { ...data },
        { headers: { 'Content-Type': 'application/json' } },
    );
